import hdrm from '../hdrm';

const createLink = (documentNode, href) => {
  const link = documentNode.createElement('link');

  link.href = href;
  link.rel = 'stylesheet';

  hdrm.injections.bindings.mutation.ignore(link);

  return link;
};

export default createLink;
